<div mat-dialog-title>
  <span>
    {{
      (cellJson.link ? 'POPUPS.ITEM_LINK_DIAG_TITLE_SUCCESS' : 'POPUPS.ITEM_LINK_DIAG_TITLE')
        | translate
    }}
  </span>
  <q9-dialog-close-button></q9-dialog-close-button>
</div>

<mat-dialog-content class="content">
  <form [formGroup]="form" #formTemplate="ngForm" class="form-content">
    <q9-text-field
      formControlName="url"
      [label]="'POPUPS.ATTACHMENT_URL_LABEL' | translate"
      [placeholder]="'POPUPS.URL_PH' | translate"
      class="url-field"></q9-text-field>
    <q9-icon-button
      icon="follow-link"
      [disabled]="form.invalid"
      (click)="openLink()"></q9-icon-button>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <q9-secondary-button mat-dialog-close>
    {{ 'POPUPS.CANCEL' | translate }}
  </q9-secondary-button>
  <q9-primary-button (click)="formTemplate.onSubmit($event); confirm()">
    {{ 'POPUPS.ATTACH' | translate }}
  </q9-primary-button>
</mat-dialog-actions>
